import { Button } from "@/components/ui/button"
import {useNavigate} from "react-router";

export function SiteHeader() {
  const navigate = useNavigate()

  function logout() {
    localStorage.removeItem('auth-token')
    navigate('/log-in')
  }

  return (
    <header className="flex  shrink-0 items-center gap-2 ">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6 py-2">
        <div className="ml-auto flex items-center gap-2">
          <Button variant="ghost" onClick={logout} size="sm" className="hidden sm:flex">
              Logout
          </Button>
        </div>
      </div>
    </header>
  )
}
